import React, { useState, useEffect } from 'react';
import { X, Megaphone } from 'lucide-react';

const DISMISSED_KEY = 'genzox_announcement_dismissed_v1';

const AnnouncementBanner = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem(DISMISSED_KEY) || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/announcements`);
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setAnnouncements(data);
      } catch (err) { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, []);

  const visible = announcements.filter((a) => !dismissed.includes(a.announcement_id));
  if (visible.length === 0) return null;
  const ann = visible[0];

  const dismiss = () => {
    const next = [...dismissed, ann.announcement_id];
    setDismissed(next);
    try { localStorage.setItem(DISMISSED_KEY, JSON.stringify(next)); } catch (err) { /* ignore */ }
  };

  return (
    <div className="bg-gradient-to-r from-[#1800ad] to-[#ff8500] text-white" data-testid="announcement-banner">
      <div className="max-w-[1440px] mx-auto px-3 sm:px-8 lg:px-12 py-2 flex items-center gap-3">
        <Megaphone size={14} className="flex-shrink-0" />
        <a href={ann.url || '/'} className="flex-1 min-w-0 text-xs sm:text-sm hover:underline">
          <strong className="font-bold">{ann.title}</strong>
          <span className="hidden sm:inline"> — {ann.body}</span>
        </a>
        <button onClick={dismiss} className="p-1 rounded hover:bg-white/20" data-testid="dismiss-announcement" aria-label="Dismiss">
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
